// extracted by mini-css-extract-plugin
export default {"bimFiltersContainer":"bimFilters_bimFiltersContainer__IgaZw","collapsableComponent":"bimFilters_collapsableComponent__W4Vfg"};